import React from 'react';
import { BuildingIcon, ShoppingBagIcon, ShieldIcon, ShieldCheckIcon, EyeIcon, AlertCircleIcon, UserCheckIcon } from 'lucide-react';
export function Specializations() {
  const specializations = [{
    title: 'Objectbeveiliging',
    icon: <BuildingIcon className="w-10 h-10 text-orange-500" data-id="element-397" />,
    description: 'Professionele beveiliging van winkels, kantoren en bedrijfspanden.'
  }, {
    title: 'Retail Beveiliging',
    icon: <ShoppingBagIcon className="w-10 h-10 text-orange-500" data-id="element-398" />,
    description: 'Gespecialiseerd in winkeldiefstalpreventie en veiligheid in winkelomgevingen.'
  }, {
    title: 'Calamiteitenbeheersing',
    icon: <AlertCircleIcon className="w-10 h-10 text-orange-500" data-id="element-399" />,
    description: 'BHV Ploegleider met expertise in het coördineren van noodsituaties.'
  }, {
    title: 'Toegangscontrole',
    icon: <ShieldCheckIcon className="w-10 h-10 text-orange-500" data-id="element-400" />,
    description: 'Secure toegangscontrole voor gebouwen, evenementen en besloten bijeenkomsten.'
  }, {
    title: 'Observatie & Rapportage',
    icon: <EyeIcon className="w-10 h-10 text-orange-500" data-id="element-401" />,
    description: 'Nauwkeurige observatie en gedetailleerde beveiligingsrapportages.'
  }, {
    title: 'Sleutelbeheer',
    icon: <ShieldIcon className="w-10 h-10 text-orange-500" data-id="element-402" />,
    description: 'Verantwoordelijk sleutelbeheer en pand openen/afsluiten volgens veiligheidsprotocollen.'
  }, {
    title: 'Teamcoördinatie',
    icon: <UserCheckIcon className="w-10 h-10 text-orange-500" data-id="element-403" />,
    description: 'Coördinatie van beveiligingsteams en aansturing bij complexe situaties.'
  }];
  return <section id="services" className="py-16 border-b border-gray-800" data-id="element-404">
      <div className="max-w-6xl mx-auto" data-id="element-405">
        <h2 className="text-3xl font-bold mb-12 text-center" data-id="element-406">
          Beveiligingsspecialisaties
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-407">
          {specializations.map((spec, index) => <div key={index} className="bg-gray-800 p-6 rounded-lg hover:bg-gray-750 transition-all border-t-2 border-orange-500 shadow-md hover:shadow-lg" data-id="element-408">
              <div className="mb-4 p-3 bg-gray-700 inline-block rounded-full" data-id="element-409">
                {spec.icon}
              </div>
              <h3 className="text-xl font-semibold mb-2" data-id="element-410">{spec.title}</h3>
              <p className="text-gray-400" data-id="element-411">{spec.description}</p>
            </div>)}
        </div>
      </div>
    </section>;
}